import { render, staticRenderFns } from "./CategorySelector.vue?vue&type=template&id=6dc5c2a1&scoped=true"
import script from "./CategorySelector.vue?vue&type=script&lang=ts"
export * from "./CategorySelector.vue?vue&type=script&lang=ts"
import style0 from "./CategorySelector.vue?vue&type=style&index=0&id=6dc5c2a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc5c2a1",
  null
  
)

export default component.exports